// Backend Sestek.AgenticCX.Domain.Constants.WrapUp.WrapUpDefinitionConsts ile birebir eşleşir.
export const PredefinedWrapUpCodeId = {
  SessionInterrupted: 7,
  NotPrompted: 8,
  Resolved: 9,
  DoNotCall: 10,
  CallbackRequested: 11,
  Misrouted: 12,
  Unreachable: 13,
  AnsweringMachine: 14,
} as const;
